<template>
  <nav class="c-breadcrumbs" aria-label="breadcrumb">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      <li
        v-for="(item, i) in items"
        :key="item.text"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        class="c-breadcrumbs__item"
      >
        <component
          :is="htmlTag(item, i)"
          itemprop="item"
          itemscope
          itemtype="https://schema.org/WebPage"
          :itemid="item.href || undefined"
          class="c-breadcrumbs__link"
          :href="item.href || undefined"
          v-text="item.text"
        ></component>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'ComponentsBreadcrumbs',
  props: {
    items: { type: Array, default: [{ text: 'TOP' }] },
  },
  methods: {
    htmlTag(item, index) {
      return item.href && this.items.length !== index + 1 ? 'a' : 'span'
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/snippets/breadcrumbs-band';

.c-breadcrumbs {
  @extend .sn-breadcrumbs-band;
  @extend .sn-breadcrumbs-band--transparent;

  &__item {
    @extend .sn-breadcrumbs-band__item;
  }

  &__link {
    @extend .sn-breadcrumbs-band__link;
  }
}
</style>
